export const featuredComics = [1, 2, 8, 15, 3];
export const hotComics = [1, 14, 4, 9, 16, 6];
export const latestUpdates = [1, 8, 4, 14, 7, 10, 11, 2];
export const popularRanking = [2, 15, 1, 13, 6, 3, 8, 5, 12, 14];